import anime from "animejs/lib/anime";

export default {
	name: 'Timelapse',
	props: {
		duration: {
			type: Number,
			default: 8000
		},
		items: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			animation: null,
		};
	},
	mounted() {
		if (this.items > 1) {
			this.animation = anime({
				targets: this.$refs.progress,
				width: ["0%", "100%"],
				easing: "linear",
				duration: 5000,
				begin() { },
				complete: () => {
					this.$emit("next");
					this.animation.play();
				}
			});

			this.animation.play();
		}


	},
	template: `
		<div class="timelapse" @mouseover="()=>{animation ? animation.pause() : null}" @mouseleave="()=>{animation ? animation.play() : null}">
			<slot />
			<div class="timelapse__track" v-if="items > 1">
				<div class="timelapse__progress" ref="progress"></div>
			</div>
		</div>
	`,
}
